@if (!appSettings.isMobile()) {
  <div>
    <div class="row mb-3 align-items-end g-2">
      <div class="col-md-4">
        <label class="form-label small text-muted mb-1">Buscar</label>
        <input type="text" class="form-control" placeholder="Nombre o slug"
          [(ngModel)]="searchText" (ngModelChange)="applyFilters()">
      </div>
      <div class="col-md-2">
        <label class="form-label small text-muted mb-1">Estado</label>
        <select class="form-select" [(ngModel)]="activeFilter" (ngModelChange)="applyFilters()">
          <option value="all">Todos</option>
          <option value="active">Activos</option>
          <option value="inactive">Inactivos</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label small text-muted mb-1">Vence</label>
        <select class="form-select" [(ngModel)]="expireFilter" (ngModelChange)="applyFilters()">
          <option value="all">Todos</option>
          <option value="yes">Con vencimiento</option>
          <option value="no">Sin vencimiento</option>
        </select>
      </div>
      <div class="col-md-4 d-flex justify-content-end">
        <ng-content></ng-content>
      </div>
    </div>

    <div class="table-responsive table-data mb-3">
      <table class="table table-hover table-sm align-middle">
        <thead>
          <tr>
            <th role="button" (click)="orderCol('name')">Nombre</th>
            <th role="button" (click)="orderCol('slug')">Slug</th>
            <th role="button" (click)="orderCol('order')">Orden</th>
            <th>Vence</th>
            <th role="button" (click)="orderCol('isActive')">Activo</th>
            <th><i class="fas fa-cog"></i></th>
          </tr>
        </thead>
        <tbody>
          @if (isLoading) {
            @for (i of rows; track $index) {
              <tr>
                @for (c of [1,2,3,4,5]; track c) {
                  <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                }
              </tr>
            }
          }
          @for (row of filtered; track row.slug) {
            <tr [class.table-active]="selectedSlug() === row.slug">
              <td>{{ row.name }}</td>
              <td><code class="small">{{ row.slug }}</code></td>
              <td>{{ row.order ?? 0 }}</td>
              <td>
                @if (row.allowExpiration) {
                  <span class="badge text-bg-warning">Sí</span>
                } @else {
                  <span class="text-muted small">No</span>
                }
              </td>
              <td><input type="checkbox" [checked]="row.isActive !== false" disabled></td>
              <td>
                @if (perm.canCurrent('canUpdate')) {
                  <button class="btn btn-outline-primary btn-xs" (click)="selectType(row)" title="Editar">
                    <i class="fas fa-pencil"></i>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (!isLoading && filtered.length === 0) {
        <div class="m-l-10 mb-2"><em>No hay tipos de documento</em></div>
      }
    </div>
  </div>
} @else {
  <app-mobile-footer>
    <input type="search" class="form-control mobile-footer-search"
      placeholder="Buscar nombre o slug..."
      [(ngModel)]="searchText" (ngModelChange)="applyFilters()">
  </app-mobile-footer>

  <div class="d-flex justify-content-between align-items-center mb-2 px-1">
    <span class="small text-muted fw-bold text-uppercase">
      TIPOS @if (!isLoading) { ({{ filtered.length }}) }
    </span>
  </div>

  <div class="mobile-cards-scroll">
    @if (isLoading) {
      @for (i of rows; track $index) {
        <app-list-card [isLoading]="true"></app-list-card>
      }
    } @else {
      @for (row of filtered; track row.slug) {
        <app-list-card [isShortcut]="true" (click)="selectType(row)">
          <div cardTitle class="fw-bold text-dark text-truncate">{{ row.name }}</div>
          <div cardBadge>
            @if (row.allowExpiration) {
              <span class="badge text-bg-warning">Vence</span>
            }
          </div>
          <div class="small text-muted"><code>{{ row.slug }}</code></div>
        </app-list-card>
      }
    }
    @if (!isLoading && filtered.length === 0) {
      <div class="card border-0 shadow-sm p-4 text-center my-2">
        <i class="fas fa-file-signature fa-3x text-muted opacity-50 mb-2"></i>
        <h6 class="text-muted mb-1">Sin tipos</h6>
      </div>
    }
  </div>
}
